module.exports = __webpack_public_path__ + "img/ekyc-logo.edfcdb97.svg";